import { Inject, NgModule, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Attachment, ICustomer, ILead, IPendingPayment, IPendingPaymentDTO, IResponse, ITicketTopic } from './shared-interface.types';
import { isEmpty, map, reject } from 'lodash';
import { SharedServiceService } from './shared-service.service';
import { WebStorage } from './web.storage';
import { IAddOn } from './interfaces.types';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,

  ]
})
export class SharedMethodsModule {

  private addressStripped: any;
  private searchType: any;

  constructor(
    private _sharedService: SharedServiceService,
    private _webStorage: WebStorage,
    
    @Inject(PLATFORM_ID) private platformId: any
  ) {

  }

  // ---------------------------------------------------------- //
  // ======================== Customer =========================//
  // ---------------------------------------------------------- //
  public async downloadStatement(statementID: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.downloadStatement(statementID)
        .subscribe({
          next: (statementBlob: any) => {
            resolve({ success: true, result: statementBlob })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getInvoiceById(id: number) {
    return new Promise(resolve => {
      this._sharedService.getInvoiceById(id)
        .subscribe({
          next: (invoice: any) => {
            resolve({ success: true, result: invoice })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async emailStatement(entityAccountID: number, statementID: number, fromDate: any, toDate: any): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.emailStatement(entityAccountID, statementID, fromDate, toDate)
        .subscribe({
          next: (res: any) => {
            resolve({ success: true, result: res })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getCustomerStatements(entityAccountID: number, status: string): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getCustomerStatements(entityAccountID, status)
        .subscribe({
          next: (statementList: any) => {
            resolve({ success: true, result: statementList })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async generateStatement(fromDate: any, toDate: any, entityAccountID: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.generateStatement(fromDate, toDate, entityAccountID)
        .subscribe({
          next: (statementList: any) => {
            resolve({ success: true, result: statementList })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }


  public async getCustomerAccount(): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getCustomerAccount()
        .subscribe({
          next: (customer: ICustomer) => {
            resolve({ success: true, result: customer })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }
  public async getCustomerInvoices() {
    return new Promise(resolve => {
      this._sharedService.getCustomerInvoices()
        .subscribe({
          next: (invoices: any) => {
            resolve({ success: true, result: invoices })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getCustomerPayments(): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getCustomerPayments()
        .subscribe({
          next: (paymentMethods: any) => {
            resolve({ success: true, result: paymentMethods })
          }, error: (err) => {
           resolve({ success: false, error: null })
          }
        })
    })
  }

  public async getCustomerBillingItems(): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getCustomerBillingItems()
        .subscribe({
          next: (services: any) => {
            resolve({ success: true, result: services })
          }, error: (err) => {
           resolve({ success: false, error: null })
          }
        })
    })
  }

  public async getCustomerLeads(): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getCustomerLeads()
        .subscribe({
          next: (leads: any) => {
            resolve({ success: true, result: leads })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getCustomerActiveServices(): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getCustomerActiveServices()
        .subscribe({
          next: (leads: any) => {
            resolve({ success: true, result: leads })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async updateCustomerAccount(data: any) {
    return new Promise(resolve => {
      this._sharedService.updateCustomerAccount(data)
        .subscribe({
          next: (customer: any) => {
            resolve({ success: true, result: customer })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getCustomerBalance(entityAccountID: number) {
    return new Promise(resolve => {
      this._sharedService.getCustomerBalance(entityAccountID)
        .subscribe({
          next: (customerBalance: any) => {
            resolve({ success: true, result: customerBalance })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async linkAccountToLead(leadId: any, accountId: any) {
    return new Promise(resolve => {
      this._sharedService.linkAccountToLead(leadId, accountId)
        .subscribe({
          next: (res: any) => {
            resolve({ success: true, result: res })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getCustomerRadiusUsage(serviceAccountEntityID: number) {
    return new Promise(resolve => {
      this._sharedService.getCustomerRadiusUsage(serviceAccountEntityID)
        .subscribe({
          next: (res: any) => {
            resolve({ success: true, result: res })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getCustomerRadiusActions(serviceAccountEntityID: number, key: string, aggregation?: string) {
    return new Promise(resolve => {
      this._sharedService.getCustomerRadiusActions(serviceAccountEntityID, key, aggregation)
        .subscribe({
          next: (res: any) => {
            resolve({ success: true, result: res })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  // ---------------------------------------------------------- //
  // ======================== Debit Order ======================//
  // ---------------------------------------------------------- //

  public async changeDebitOrderDate(account: object): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.changeDebitOrderDate(account)
        .subscribe({
          next: (order: any) => {
            resolve({ success: true, result: order })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }



  public async getDebitOrderMandateStatus(leadId: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getDebitOrderMandateStatus(leadId)
        .subscribe({
          next: (order: any) => {
            resolve({ success: true, result: order })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getDebitOrder(LeadEntityId: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getDebitOrder(LeadEntityId)
        .subscribe({
          next: (debitOrder: any) => {
            resolve({ success: true, result: debitOrder })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }


  public async rejectDebitOrderMandate(EntityAccountDebitOrderMandateID: number) {
    return new Promise(resolve => {
      this._sharedService.rejectDebitOrder(EntityAccountDebitOrderMandateID)
        .subscribe({
          next: (debitOrder: any) => {
            resolve({ success: true, result: debitOrder })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async acceptDebitOrderOTP(EntityAccountDebitOrderMandateID: number) {
    return new Promise(resolve => {
      this._sharedService.acceptDebitOrderOTP(EntityAccountDebitOrderMandateID)
        .subscribe({
          next: (debitOrder: any) => {
            resolve({ success: true, result: debitOrder })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getLatestPendingDO() {
    return new Promise(resolve => {
      this._sharedService.getLatestPendingDO()
        .subscribe({
          next: (debitOrder: any) => {
            resolve({ success: true, result: debitOrder })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async authoriseMandateWithOTP(EntityAccountDebitOrderMandateID: number, OTP: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.authoriseMandateWithOTP(EntityAccountDebitOrderMandateID, OTP)
        .subscribe({
          next: (debitOrder: any) => {
            resolve({ success: true, result: debitOrder })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }


  public async generateDebitOrderMandate(leadEntityID: number, entityAccountID: number, debitAmount: number, paymentMethod: any) {
    return new Promise(resolve => {
      this._sharedService.generateDebitOrderMandate(leadEntityID, entityAccountID, debitAmount, paymentMethod)
        .subscribe({
          next: (debitOrderMandateGenerated: any) => {
            resolve({ success: true, result: debitOrderMandateGenerated })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async isDebitOrderRequired(LeadEntityId: number) {
    return new Promise(resolve => {
      this._sharedService.isDebitOrderRequired(LeadEntityId)
        .subscribe({
          next: (doRequired: any) => {
            resolve({ success: true, result: doRequired })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }


  // ## ORGANIZES ORDERS WITH MANDATE DETAILS ##
  public async getDebitOrderMandatesDetails(orderArray: any) {
    const debitOrderMandateList = [];
    const promises = orderArray?.map(async element => {
      const res: any = await this.getDebitOrder(element?.LeadEntityID);
      const validOrder = res?.result?.find(debitItem => { debitItem.Status === 'Pending' || debitItem.Status === 'Accepted' });
      if (validOrder) {
        debitOrderMandateList.push(validOrder);
      } else {
        if (res?.result?.length >= 1) {
          debitOrderMandateList.push(res?.result[0]);
        }
      }
    });

    function sortDebitOrderMandates(data: any) {
      let orderedDataArray = [];
      orderArray.forEach(orderItem => {
        let matchedEntity = data?.find(debitItem => debitItem.LeadEntityID === orderItem?.LeadEntityID);
        if (matchedEntity !== undefined && !isEmpty(matchedEntity)) {
          let combinedObject = {
            ...orderItem,
            DebitOrderData: matchedEntity
          };
          orderedDataArray.push(combinedObject);
        } else {
          if (orderItem?.LeadActionTypeCode === "Order") {
            orderedDataArray.push(orderItem);
          }
        }
      });
      return orderedDataArray
    };

    await Promise.all(promises);
    this._sharedService.debitOrderMandateDetailsArray = sortDebitOrderMandates(debitOrderMandateList);
    return this._sharedService.debitOrderMandateDetailsArray;
  }

  // ## GETS CURRENT ACTIVE SERVICES ##
  public async getCustomerLeadsArray() {
    const promise = await this.getCustomerLeads().then(async (res) => {
      let response = [];
      for (const element of res?.result || []) {
        switch (element?.LeadActionTypeCode) {
          case "Order":
            const mandateStatus = await this.getDebitOrderMandateStatus(element?.LeadEntityID);
            element["DebitOrderMandateRequired"] = mandateStatus?.result;
            response.push(element);
            break;
          case "PreOrder":
            const mandatePreOrderStatus = await this.getDebitOrderMandateStatus(element?.LeadEntityID);
            element["DebitOrderMandateRequired"] = mandatePreOrderStatus?.result;
            response.push(element);
            break;
          case "ServiceCancellation":
            response.push(element);
            break;
          case "ServiceDowngrade":
            response.push(element);
            break;
          case "ServiceUpgrade":
            response.push(element);
            break;
          default:
            break;
        }
      }
      this._sharedService.debitOrdersArray = response;
      return response;
    });
    await Promise.all(promise);
    return promise;
  }

  public async CancelOrder(LeadEntityId: number, reason: any, cancellationComment: any): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.cancelDebitOrder(LeadEntityId, reason, cancellationComment)
        .subscribe({
          next: (cancelResponse: any) => {
            resolve({ success: true, result: cancelResponse })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async GetRegrades(accountofferableEntityId: number, actionType: string): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getRegradeOptions(accountofferableEntityId, actionType)
        .subscribe({
          next: (regradeOptions: any) => {
            resolve({ success: true, result: regradeOptions })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }


  // ---------------------------------------------------------- //
  // ===================== BANK DETAILS ========================//
  // ---------------------------------------------------------- //
  public async getBankLists(): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getBankList()
        .subscribe({
          next: (banks: any) => {
            resolve({ success: true, result: banks })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getBankAccountTypeList(): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getBankAccountTypeList()
        .subscribe({
          next: (bankAccountTypes: any) => {
            resolve({ success: true, result: bankAccountTypes })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }


  public async getDebitOrderCollectionRuns(): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getDebitOrderCollectionRuns()
        .subscribe({
          next: (collection: any) => {
            resolve({ success: true, result: collection })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }




  // ---------------------------------------------------------- //
  // ==================== PAYMENT METHODS=======================//
  // ---------------------------------------------------------- //
  public async getPaymentMethods(): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getPaymentMethods()
        .subscribe({
          next: (paymentMethods: any) => {
            resolve({ success: true, result: paymentMethods })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async addPaymentMethods(paymentMethodDTO: any): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.addPaymentMethods(paymentMethodDTO)
        .subscribe({
          next: (paymentMethodDTO: any) => {
            resolve({ success: true, result: paymentMethodDTO })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async previewDebitOrderMandate(entityAccountDebitOrderMandateID: number, token: string) {
    return this._sharedService.previewDebitOrderMandate(entityAccountDebitOrderMandateID, token)
  }


  // ---------------------------------------------------------- //
  // ==================== TICKETS=======================//
  // ---------------------------------------------------------- //
  public async getTicketTopics(): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getTicketTopics()
        .subscribe({
          next: (ticketTopic: ITicketTopic) => {
            resolve({ success: true, result: ticketTopic })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async createTicket(ticketData: any) {
    return new Promise(resolve => {
      this._sharedService.createTicket(ticketData)
        .subscribe({
          next: (ticketCreated: any) => {
            resolve({ success: true, result: ticketCreated })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getAllTickets() {
    return new Promise(resolve => {
      this._sharedService.getAllTickets()
        .subscribe({
          next: (tickets: any) => {
            resolve({ success: true, result: tickets })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getAllTicketMessages(id: string) {
    return new Promise(resolve => {
      this._sharedService.getAllTicketMessages(id)
        .subscribe({
          next: (messages: any) => {
            resolve({ success: true, result: messages })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async sendTicketMessage(ticketNumber: number, message: string) {
    return new Promise(resolve => {
      this._sharedService.sendTicketMessage(ticketNumber, message)
        .subscribe({
          next: (response: any) => {
            resolve({ success: true, result: response })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }



  // ---------------------------------------------------------- //
  // ======================== PACKAGES =========================//
  // ---------------------------------------------------------- //
  public async getAvailablePackages(leadEntityID: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getAvailablePackages(leadEntityID)
        .subscribe({
          next: (packages: any) => {
            resolve({ success: true, result: packages })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getAllPackages(): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getAllPackages()
        .subscribe({
          next: (packages: any) => {
            const filteredPackages = packages.value.filter((element) => element.Audit_IsActive);
            resolve({ success: true, result: filteredPackages });
          },
          error: (err) => {
            resolve({ success: false, error: err });
          }
          
        });
    });
  }

  public async getPackageByID(PackageEntityId: number) {
    return new Promise(resolve => {
      this._sharedService.getPackageByID(PackageEntityId)
        .subscribe({
          next: (packageByID: any) => {
            resolve({ success: true, result: packageByID })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getLinkedOfferablesByLeadId(leadEntityID: number) {
    return new Promise(resolve => {
      this._sharedService.getLinkedOfferablesByLeadId(leadEntityID)
        .subscribe({
          next: (linkedOfferables: any) => {
            resolve({ success: true, result: linkedOfferables })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public removeSalesItemsFromLead(LeadEntityId: number) {
    return new Promise(resolve => {
      this._sharedService.removeSalesItemsFromLead(LeadEntityId)
        .subscribe({
          next: (removed: any) => {
            resolve({ success: true, result: removed })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async addPackageToLead(LeadEntityId: number, Package: any) {
    return new Promise(resolve => {
      this._sharedService.addPackageToLead(LeadEntityId, Package)
        .subscribe({
          next: (addToLead: any) => {
            resolve({ success: true, result: addToLead })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getAddons(LeadAccountEntityID: number) {
    return new Promise(resolve => {
      this._sharedService.getAddons(LeadAccountEntityID)
        .subscribe({
          next: (addons: any) => {
            resolve({ success: true, result: addons })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async addAddOnToLead(addOn: IAddOn) {
    return new Promise(resolve => {
      this._sharedService.addAddOnToLead(addOn)
        .subscribe({
          next: (addOn: any) => {
            resolve({ success: true, result: addOn })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getTermsAndConditions(PackageEntityID: number) {
    return new Promise(resolve => {
      this._sharedService.getTermsAndConditions(PackageEntityID)
        .subscribe({
          next: (terms: any) => {
            resolve({ success: true, result: terms })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getGlobalTermsAndConditions() {
    return new Promise(resolve => {
      this._sharedService.getGlobalTermsAndConditions()
        .subscribe({
          next: (globalTerms: any) => {
            resolve({ success: true, result: globalTerms })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async acceptTermsAndConditions(LeadEntityID: number, TermsAndConditionsTemplateID: number) {
    return new Promise(resolve => {
      this._sharedService.acceptTermsAndConditions(LeadEntityID, TermsAndConditionsTemplateID)
        .subscribe({
          next: (acceptedTerm: any) => {
            resolve({ success: true, result: acceptedTerm })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async setLeadActionType(leadEntityID: number, orderType: string) {
    return new Promise(resolve => {
      this._sharedService.setLeadActionType(leadEntityID, orderType)
        .subscribe({
          next: (orderType: any) => {
            resolve({ success: true, result: orderType })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  // ---------------------------------------------------------- //
  // ====================Special Product========================//
  // ---------------------------------------------------------- //

  public async packageCompletionValidate(leadEntityID: number) {
    return new Promise(resolve => {
      this._sharedService.packageCompletionValidate(leadEntityID)
        .subscribe({
          next: (packageValidated: any) => {
            resolve({ success: true, result: packageValidated })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async executeSpecialProductAction(leadEntityID: number, salesEntityId:number,  actionKey: string, actionPayload: any) {
    return new Promise(resolve => {
      this._sharedService.executeSpecialProductAction(leadEntityID, salesEntityId, actionKey, actionPayload)
        .subscribe({
          next: (specialProduct: any) => {
            resolve({ success: true, result: specialProduct })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getSpecialProductOverview(leadEntityID: number, salesEntityId: number) {
    return new Promise(resolve => {
      this._sharedService.getSpecialProductOverview(leadEntityID, salesEntityId)
        .subscribe({
          next: (specialProduct: any) => {
            resolve({ success: true, result: specialProduct })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async cancelSpecialProductOverview(entityAccountOfferableEntityID: number, actionKey: string) {
    return new Promise(resolve => {
      this._sharedService.cancelSpecialProductOverview(entityAccountOfferableEntityID, actionKey)
        .subscribe({
          next: (specialProduct: any) => {
            resolve({ success: true, result: specialProduct })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async specialProductAction(leadEntityID: number, packageEntityID: number) {
    return new Promise(resolve => {
      this._sharedService.getSpecialProductOverview(leadEntityID, packageEntityID)
        .subscribe({
          next: (specialProduct: any) => {
            resolve({ success: true, result: specialProduct })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async executeSpecialProductSubAction(leadEntityID: number, salesEntityId: number, actionKey: string, subActionKey: string, actionPayload: any) {
    return new Promise(resolve => {
      this._sharedService.executeSpecialProductSubAction(leadEntityID, salesEntityId, actionKey, subActionKey, actionPayload)
        .subscribe({
          next: (subActionExecuted: any) => {
            resolve({ success: true, result: subActionExecuted })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async requiresAddressVerification(leadEntityID: number) {
    return new Promise(resolve => {
      this._sharedService.requiresAddressVerification(leadEntityID)
        .subscribe({
          next: (requiresVerification: any) => {
            resolve({ success: true, result: requiresVerification })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getAddressVerification(leadEntityID: number, address: string) {
    return new Promise(resolve => {
      this._sharedService.getAddressVerification(leadEntityID, address)
        .subscribe({
          next: (addressVerification: any) => {
            resolve({ success: true, result: addressVerification })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  // ---------------------------------------------------------- //
  // ===================== Promo Codes =========================//
  // ---------------------------------------------------------- //
  public async getAppliedPromoCode(LeadEntityId: number) {
    return new Promise(resolve => {
      this._sharedService.getAppliedPromoCode(LeadEntityId)
        .subscribe({
          next: (promoApplied: any) => {
            resolve({ success: true, result: promoApplied })
          }, error: (err) => {
           resolve({ success: false, error: err?.error?.Message })
          }
        })
    })
  }

  public async applyPromoCode(LeadEntityId: number, PromoCode: string) {
    return new Promise(resolve => {
      this._sharedService.applyPromoCode(LeadEntityId, PromoCode)
        .subscribe({
          next: (promoApplied: any) => {
            resolve({ success: true, result: promoApplied })
          }, error: (err) => {
           resolve({ success: false, error: err?.error?.Message })
          }
        })
    })
  }

  public async getPromoSalesItems(LeadEntityId: number) {
    return new Promise(resolve => {
      this._sharedService.getPromoSalesItems(LeadEntityId)
        .subscribe({
          next: (salesItems: any) => {
            resolve({ success: true, result: salesItems })
          }, error: (err) => {
            resolve({ success: false, error: err?.error?.Message })
          }
        })
    })
  }

  // ---------------------------------------------------------- //
  // ======================== LEADS ============================//
  // ---------------------------------------------------------- //
  public async getLeadById(LeadEntityID: any): Promise<IResponse> {
    return new Promise(async resolve => {
      this._sharedService.getLeadById(LeadEntityID)
        .subscribe({
          next: (lead: any) => {
            resolve({ success: true, result: lead })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getLeadCustomStatuses(): Promise<IResponse> {
    return new Promise(async resolve => {
      this._sharedService.getLeadCustomStatuses()
        .subscribe({
          next: (customStatuses: any) => {
            resolve({ success: true, result: customStatuses })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async updateLeadWithCustomStatus(leadEntityId: number, id: number): Promise<IResponse> {
    return new Promise(async resolve => {
      this._sharedService.updateLeadWithCustomStatus(leadEntityId, id)
        .subscribe({
          next: (leadCustomStatusUpdated: any) => {
            resolve({ success: true, result: leadCustomStatusUpdated })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async customerDetailsUpdate(leadEntityId: number, contactableName: string, contactableSurname: string, contactablePhoneNumber: number): Promise<IResponse> {
    return new Promise(async resolve => {
      this._sharedService.customerDetailsUpdate(leadEntityId, contactableName, contactableSurname, contactablePhoneNumber)
        .subscribe({
          next: (customerUpdate: any) => {
            resolve({ success: true, result: customerUpdate })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getLeadSource(): Promise<IResponse> {
    return new Promise(async resolve => {
      this._sharedService.getLeadSource()
        .subscribe({
          next: (leadSource: any) => {
            resolve({ success: true, result: leadSource })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async updateLeadSourceCode(leadEntityId: number, leadSourceCodeId: number, ): Promise<IResponse> {
    return new Promise(async resolve => {
      this._sharedService.updateLeadSourceCode(leadEntityId, leadSourceCodeId)
        .subscribe({
          next: (updateLeadSourceCode: any) => {
            resolve({ success: true, result: updateLeadSourceCode })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async generateLead(offerableID: number, type: string): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.generateLead(offerableID, type)
        .subscribe({
          next: (packages: any) => {
            resolve({ success: true, result: packages })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }



  public async cancelLeadById(LeadEntityID: any) {
    return new Promise(resolve => {
      this._sharedService.cancelLeadById(LeadEntityID)
        .subscribe({
          next: (lead: any) => {
            resolve({ success: true, result: lead })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public consumeGoogleAddress(address: any, type: string) {
    let val: any = null;
    if (address.results) {
      this.addressStripped = address.results[0].address_components;
    } else {
      this.addressStripped = address.address_components;
    }

    this.addressStripped?.forEach((a: any) => {
      a.types.forEach((t: any) => {
        if (t == type) {
          val = a.short_name;
          return
        }
      })
    });
    return val
  }

  public async updateLead(lead: ILead) {
    return new Promise(resolve => {
      this._sharedService.updateLead(lead)
        .subscribe({
          next: (updateLead: any) => {
            resolve({ success: true, result: updateLead })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async doFeasibility(coords: any, address?: any, customer?: ICustomer, LeadActionTypeCode?: string, updatingEntityAccountOfferableId?: number, LeadAccountEntityID?: number, LeadEntityID?: number) {
    const data = {
      Audit_IsActive: false,
      AutoGenerateCollaborators: true,
      Fibre_Feasibility_DoTest: true,
      IsFeasibilityLead: true,
      LeadActionTypeCode: LeadActionTypeCode ?? 'Feasibility',
      LeadBusinessName: '',
      LeadContactEmail: customer?.EmailAddress,
      LeadContactIDNumber: customer?.IDNumber,
      LeadContactName: customer?.FirstName,
      LeadContactSurname: customer?.Surname,
      LeadContactNumber: customer?.MobileNumber,
      LeadCustomerTypeCode: 'Residential',
      LeadDescription: '',
      LeadSource: 'PUBLIC',
      Microwave_Feasibility_DoTest: true,
      Mobile_Feasibility_DoTest: true,
      SiteContactEmail: '',
      SiteContactName: '',
      SiteContactNumber: '',
      Longitude: coords.longitude,
      Latitude: coords.latitude,
      StreetNumber: address !== null ? await this.consumeGoogleAddress(address, 'street_number') : null,
      StreetName: address !== null ? await this.consumeGoogleAddress(address, 'route') : null,
      Suburb: address !== null ? await this.consumeGoogleAddress(address, 'sublocality_level_1') : null,
      Town: address !== null ? await this.consumeGoogleAddress(address, 'locality') : null,
      City: address !== null ? await this.consumeGoogleAddress(address, 'administrative_area_level_2') : null,
      Region: address !== null ? await this.consumeGoogleAddress(address, 'administrative_area_level_1') : null,
      Country: address !== null ? await this.consumeGoogleAddress(address, 'country') : null,
      PostalCode: address !== null ? await this.consumeGoogleAddress(address, 'postal_code') : null,
      UpdatingEntityAccountOfferableID: updatingEntityAccountOfferableId,
      LeadAccountEntityID: LeadAccountEntityID,
      LeadEntityID: LeadEntityID
    }

    return new Promise(resolve => {
      this._sharedService.feasability(data)
        .subscribe({
          next: (feasibility: any) => {
            this._webStorage.StoredLead.next(feasibility);
            localStorage.setItem('LeadEntityId', feasibility.LeadEntityID);
            resolve({ success: true, result: feasibility });
          }, error: (err) => {
            localStorage.setItem('LeadEntityId', "0");
           resolve({ success: false, error: err });
          }
        })
    });
  }

  public geoCode(place?: any, coords?: { latitude: number, longitude: number }, customer?: ICustomer) {

    if (isPlatformBrowser(this.platformId)) {
      return new Promise(resolve => {
        const geocoder = new window.google.maps.Geocoder()
        if (place !== null) {
          this.searchType = { address: place?.formatted_address, }
        } else {
          this.searchType = { location: { lat: coords.latitude, lng: coords.longitude } }
        }

        geocoder.geocode(
          // look at the above if as that depends on the object being used to search
          this.searchType
        ).then(async (response) => {
          const coords = {
            latitude: response.results[0].geometry.location.lat(),
            longitude: response.results[0].geometry.location.lng()
          }
          this._webStorage.SetCustomerCoordinates(coords);

          resolve(await this.doFeasibility(coords, response, customer));
        })
          .catch(err => {
            reject('Invalid request, please try again!');
          })
      })
    }
  }




  // ---------------------------------------------------------- //
  // ======================== Services =========================//
  // ---------------------------------------------------------- //
  public async getCancelationReasonOData(): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getCancelationReasonOData()
        .subscribe({
          next: (OData: any) => {
            resolve({ success: true, result: OData })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getServiceCancellationReasons(): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.serviceCancellationReasons()
        .subscribe({
          next: (OData: any) => {
            resolve({ success: true, result: OData })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async cancelService(data: any): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.cancelService(data)
        .subscribe({
          next: (cancelResponse: any) => {
            resolve({ success: true, result: cancelResponse })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }




  // ---------------------------------------------------------- //
  // ======================== PAYMENTS =========================//
  // ---------------------------------------------------------- //

  public async payNow(data: any): Promise<IResponse> {
    const generatePendingPaymentResults = await this.generatePendingPayment(data);
    let result = null;

    if (generatePendingPaymentResults.success && isPlatformBrowser(this.platformId) ) {
      // generate the payment links
      // debugger
      // console.log(generatePendingPaymentResults);
      const generatePaymentLinksResult = await this.generatePaymentLinks(generatePendingPaymentResults.result, window.location.href);
      // console.log(generatePaymentLinksResult);
      if (generatePaymentLinksResult.success) {
        result = generatePaymentLinksResult
      }
    }
    else {
      const error = generatePendingPaymentResults?.error?.error?.Message;
      if (error?.includes('pending') && isPlatformBrowser(this.platformId)) {
        // this means there is a pending receipt
        // make that payment              
        const getPendingPaymentResult = await this.getPendingPayment(data.leadEntityId);
        if (getPendingPaymentResult.success) {
          const pendingPayment = getPendingPaymentResult.result;
          const generatePaymentLinksResult = await this.generatePaymentLinks(pendingPayment, window.location.href);
          if (generatePaymentLinksResult.success) {
            result = generatePaymentLinksResult;
          }
        }
      }
    }

    return result
  }

  public async getPendingPayment(leadEntityId: any): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getPendingPayment(leadEntityId)
        .subscribe({
          next: (pendingPayment: any) => {
            resolve({ success: true, result: pendingPayment })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async generatePaymentLinks(PendingPayment: IPendingPayment, redirectURL: string): Promise<IResponse> {

    // the below inline if is becasue if a new pending payment is created it does not return as an array 
    // if there is a pending receipt in the account
    // returns as array hence the [0]   
    return new Promise(resolve => {
      this._sharedService.generatePaymentLinks(Array.isArray(PendingPayment) ? PendingPayment[0].EntityAccountReceiptID : PendingPayment.EntityAccountReceiptID, redirectURL)
        .subscribe({
          next: (links: any) => {
            resolve({ success: true, result: links })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getUpfrontAmountDue(LeadEntityID: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getUpfrontAmountDue(LeadEntityID)
        .subscribe({
          next: (upfrontAmount: any) => {
            resolve({ success: true, result: upfrontAmount })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async generatePendingPayment(DTO: IPendingPaymentDTO): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.generatePendingPayment(DTO)
        .subscribe({
          next: (pendingPayment: any) => {
            resolve({ success: true, result: pendingPayment })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }


  // ---------------------------------------------------------- //
  // ======================== Upload Files =====================//
  // ---------------------------------------------------------- //
  public async uploadFile(fileObject): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.uploadFile(fileObject)
        .subscribe({
          next: (response: any) => {
            resolve({ success: true, result: response })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async attachment(response: Attachment): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.attachment(response)
        .subscribe({
          next: (response: any) => {
            resolve({ success: true, result: response })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  public async getAllAttachments(entityId: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getAllAttachments(entityId)
        .subscribe({
          next: (response: any) => {
            resolve({ success: true, result: response })
          }, error: (err) => {
           resolve({ success: false, error: err })
          }
        })
    })
  }

  // ---------------------------------------------------------- //
  // ====================== Channel Partner ====================//
  // ---------------------------------------------------------- //
  public async getChannelPartnerOrder(LeadEntityID: number): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.getChannelPartnerOrder(LeadEntityID)
        .subscribe({
          next: (response: any) => {
            resolve({ success: true, result: response })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async createChannelPartnerOrder(
    LeadEntityID: number,
    emailVerificationToken: string,
    emailVerified: boolean,
    leadRegistrationToken: string,
    passwordReset: boolean,
    passwordResetToken: string,
    userName: string): Promise<IResponse> {
      
    return new Promise(resolve => {
      this._sharedService.createChannelPartnerOrder(LeadEntityID, emailVerificationToken, emailVerified, leadRegistrationToken, passwordReset, passwordResetToken, userName)
        .subscribe({
          next: (response: any) => {
            resolve({ success: true, result: response })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  public async channelPartnerOrder(leadID: number, detailsUpdated: boolean) {
    return new Promise(resolve => {
      this._sharedService.channelPartnerOrder(leadID, detailsUpdated)
        .subscribe({
          next: (channelPartnerOrder: any) => {
            resolve({ success: true, result: channelPartnerOrder })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }

  // ---------------------------------------------------------- //
  // ====================== Complaints =========================//
  // ---------------------------------------------------------- //


  public async emailComplaint(formValue: any, file?: File): Promise<IResponse> {
    return new Promise(resolve => {
      this._sharedService.emailComplaint(formValue, file)
        .subscribe({
          next: (res: any) => {
            resolve({ success: true, result: res })
          }, error: (err) => {
            resolve({ success: false, error: err })
          }
        })
    })
  }


}